<template>
    <div class="py-4">
        <modal-delete v-if="ondelete" :ondelete="ondelete" :id="id" @onclose="ondelete = false" @onreload="INIT()"/>
        <header>
            <div class="container-fluid">
                <div class="pb-4">
                    <div class="row align-items-end">
                        <div class="col-sm col-12">
                            <h1 class="h2 ls-tight">Aranceles top</h1>
                        </div>
                        <div class="col-sm-auto col-12 mt-4 mt-sm-0">
                            <div class="hstack gap-2 justify-content-sm-end">
                                <router-link :to="{ name: 'TopTaxCreate' }">
                                    <button type="button" class="btn btn-h btn-primary px-3">
                                        <span>Crear</span>
                                    </button>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <main>
            <div class="container-fluid">
                <div class="vstack gap-4">
                    <div class="d-flex flex-column flex-md-row gap-3 justify-content-between">
                        <form class="d-flex gap-3 row" @submit.prevent="FILTER()">
                            <div>
                                <button @click="SORT()" type="button" class="btn btn-h px-3 btn-neutral">
                                    <i class="me-2" :class="filter.sortDesc == 'ASC' ? 'bi bi-sort-alpha-up' : 'bi bi-sort-alpha-down-alt'"></i>
                                    <span>{{ filter.sortDesc }}</span>
                                </button>
                            </div>
                            <div class="col-md-4 px-0">
                                <div class="input-group input-group-sm input-group-inline">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text pe-2 text-sm"><i class="bi bi-search"></i></span>
                                    </div>
                                    <input type="text" class="form-control" placeholder="Buscar..." v-model="filter.search">
                                </div>
                            </div>
                            <div>
                                <button type="submit" class="btn btn-h px-3 btn-primary">
                                    <div class="spinner-border spinner-border-sm" role="status" v-if="filter.loading">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span v-else>Buscar</span>
                                </button>
                            </div>
                            <div>
                                <button type="button" @click="CLEAR()" class="btn btn-h px-3 btn-danger">
                                    <span>Limpiar</span>
                                </button>
                            </div>
                        </form>
                    </div>
                    <div class="card">
                        <div class="card-header bg-white">
                            <h5 class="me-auto">Listado</h5>
                        </div>
                        <div class="card-body p-0">
                            <template>
                                <v-data-table  class="elevation-1"
                                    :headers="headers"
                                    :items="loading ? [] :items.data"
                                    :options.sync="options"
                                    :server-items-length="items.total"
                                    :loading="loading"
                                    :footer-props="{
                                        'items-per-page-options': [5, 10, 50, 100]
                                    }">
                                    <template v-slot:[`item.update`]="{ item }">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <a v-bind="attrs" v-on="on">
                                                    <router-link
                                                        :to="{ name: 'TopTaxUpdate', params: { id: item.id } }"
                                                        class="btn btn-primary btn-m">
                                                        <small><i class="bi bi-pencil-square"></i></small>
                                                    </router-link>
                                                </a>
                                            </template>
                                            <small>Editar</small>
                                        </v-tooltip>
                                    </template>
                                    <template v-slot:[`item.delete`]="{ item }">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <button @click="DELETE(item.id)" type="button" v-bind="attrs" v-on="on"
                                                    class="btn btn-danger btn-m">
                                                    <small><i class="bi bi-trash3"></i></small>
                                                </button>
                                            </template>
                                            <small>Eliminar</small>
                                        </v-tooltip>
                                    </template>
                                </v-data-table>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
import ModalDelete from './Delete'
export default {
    components: { ModalDelete },
    data() {
        return {
            headers: [
                { text: 'Descripción', value: 'description' },
                { text: 'Editar', value: 'update', sortable: false },
                { text: 'Borrar', value: 'delete', sortable: false }
            ],
            items: {
                data: [],
                total: 0,
                to: 0
            },
            loading: false,
            options: {},
            filter: {
                sortBy: 'description',
                sortDesc: 'ASC',
                search: '',
                loading: false,
            },
            ondelete: false,
            id: null,
            item: null,
            count: 0,
        }
    },
    methods: {
        INIT: function () {
            let vue = this
            vue.loading = true
            const { page, itemsPerPage } = vue.options
            const { sortBy, sortDesc, search } = vue.filter
            let query = {
                page: page,
                itemsPerPage: itemsPerPage,
                sortBy: sortBy,
                sortDesc: sortDesc,
                search: search
            }
            axios({
                url: '/top/taxes',
                method: 'GET',
                params: query
            })
                .then((resp) => {
                    vue.items = resp.data
                })
                .catch((err) => {
                    if (err.response.status === 402) {
                       let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    } else {
                        vue.$swal({ toast: true, icon: 'error', title: err.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    }
                })
                .finally((resp) => {
                    vue.loading = false
                    vue.filter.loading = false
                })
        },
        SORT: function() {
            let vue = this
            vue.filter.sortDesc = vue.filter.sortDesc == 'ASC' ? 'DESC' : 'ASC'
            vue.INIT()
        },
        FILTER: function(){
            let vue = this
            let count = 0
            if(vue.filter.search.length > 0){
                count++
            }
            if(count > 0){
                vue.filter.loading = true
                vue.INIT()
            }
        },
        CLEAR: function(){
            let vue = this
            vue.filter.search = ''
            vue.INIT()
        },
        DELETE: function (id) {
            let vue = this
            vue.id = id
            vue.ondelete = true
        },
    },
    watch: {
        options: {
            handler() {
                this.INIT()
            },
            deep: true
        }
    }
}
</script>
